import { Defined } from '../defined.js';
class AsyncResult {
    _props;
    constructor(_props) {
        this._props = _props;
    }
    props = () => {
        return this._props;
    };
    toJson = async () => {
        if (this.hadFailed()) {
            return {
                hadSucceed: false,
                reason: this.reason(),
            };
        }
        if (this.hadSucceed()) {
            return {
                hadSucceed: true,
                data: await this.data(),
            };
        }
        throw new Error('instance can only be either succeed or failed');
    };
    match = (props) => {
        if (this.hadSucceed()) {
            return props.succeed(this.data());
        }
        else if (this.hadFailed()) {
            return props.failed(this.reason());
        }
        throw new Error('instance can only be either succeed or failed');
    };
    map = async (fn) => {
        if (this.hadSucceed()) {
            const data = await fn(this.data());
            if (data instanceof Failed) {
                return Failed.create(data.reason());
            }
            return Succeed.create(data);
        }
        if (this.hadFailed()) {
            return Failed.create(this.reason());
        }
        throw new Error('instance can only be either succeed or failed');
    };
    flatMap = async (fn) => {
        if (this.hadSucceed()) {
            return fn(this.data());
        }
        if (this.hadFailed()) {
            return Failed.create(this.reason());
        }
        throw new Error('instance can only be either succeed or failed');
    };
    hadSucceed = () => {
        return this instanceof Succeed;
    };
    hadFailed = () => {
        return this instanceof Failed;
    };
}
class Succeed extends AsyncResult {
    constructor(data) {
        super({
            data,
            reason: undefined,
        });
    }
    data = () => {
        return Defined.parse(this.props().data).orThrow('data is undefined');
    };
    static create = (data) => {
        return new this(data);
    };
}
class Failed extends AsyncResult {
    constructor(reason) {
        super({
            reason,
            data: undefined,
        });
    }
    reason = () => {
        return Defined.parse(this.props().reason).orThrow('reason is undefined');
    };
    static create = (reason) => {
        return new this(typeof reason === 'string' ? new Error(reason) : reason);
    };
}
class AsyncOperation {
    static succeed = (data) => {
        return Succeed.create(data);
    };
    static failed = (reason) => {
        return Failed.create(reason);
    };
}
export { AsyncOperation, AsyncResult };
//# sourceMappingURL=async.js.map